export default __webpack_public_path__ + "static/steam_w.dcd23756e575214b3578be80225d7322.svg";